// extracted by mini-css-extract-plugin
module.exports = {"bluedivider":"FAQ_bluedivider__nvlxS"};